import { render, staticRenderFns } from "./MenuLink.vue?vue&type=template&id=47955c08&functional=true&"
import script from "./MenuLink.vue?vue&type=script&lang=js&"
export * from "./MenuLink.vue?vue&type=script&lang=js&"
import style0 from "./MenuLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports